module.exports = __webpack_public_path__ + "static/29-4c2daaba5cf85b16191478237f763674.jpg";